export default {
    "appName": "Designshark LLC",
    "appEmail": "business@designsharkllc.com",
    "domain": process.env.NODE_ENV === 'production' ? "https://www.designsharkllc.com" : "http://127.0.0.1:8000",
    "title": "Designshark LLC | Platform Design Agency for Businesses",
    "shortDesc": "Platform Design Agency for Businesses",
    "description": "Designshark LLC is a platform design agency for businesses, connecting modern visual designers with you. We are the best place to get the pro designers and creative experts competing to create awesome designs for you!",
    "localUserKey" : "ioqpzxisjdffrydogkxybqhmboy",
}
